import React, { useState } from 'react'
 

import { useMutation } from 'react-query'
import { toast } from 'react-toastify'



import { postAttendance } from '../../../../MyApi/hr/attendances'

import PageHeader from '../../../../Components/UI/PageHeader'
import AddAttendance from '../../../../Components/hr/attendance/attendanceStore/AddAttendance'



const AttendanceStore = () => {
const [q ,setQ]= useState("")
const [date,setDate] =useState("")
const [time ,setTime]=useState("")
const [Type,setType]=useState("")
const [sb_employe_id, setEmployId]=useState("")

 
 const mutation = useMutation("postAttendance" , (postData)=>postAttendance(postData) ,{
    onSuccess:(data)=>{
        toast.success(`${data.message}`)
        setQ("")
        setDate("")
        setTime("")
        setType("")
      

    },
    onError:(error)=>{
        toast.error(`${error.response.data.message}`)
    }
 })

 const handlePostRequest =()=>{
    mutation.mutate({
        q,  
        type:"manual",
        sb_employe_id,
        time ,date

    })
 }
 const isDisabled = () => {
    return !(q) 
}
  return ( 

    <div>
        <PageHeader title="Add Attendance" showBack={true}  saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
        <AddAttendance setQ={setQ} employId={sb_employe_id} setDate={setDate} setTime={setTime}  setEmployId={setEmployId}  setType={setType} />
    </div>
  )
}

export default AttendanceStore